/* eslint-disable react/no-deprecated */
import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Iframe from 'react-iframe';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SketchPicker } from 'react-color';
import { withRouter } from 'react-router-dom';
import { List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import * as actions from '../../actions/index';
import { styles } from './Design.styles';
import {
  handleChangeComplete,
  initStates,
  changeDesign,
  changeSwitchValueMode,
  getBottomNavigationData,
  changeSwitchValue,
  getCommonBottomNavigationData
} from './Design.services';
import {
  Button,
  BottomNavigationIcon,
  Paper,
  Input,
  Spinner,
  BackButton,
  Swatch
} from '../../components';
import { UNIT, marketing, LIST_DESIGN_TYPE } from '../../constants';
import mobileLight from '../../assets/pictures/mobileLight.png';
import mobileDark from '../../assets/pictures/mobileDark.png';
import colorIcon from '../../assets/pictures/colorIcon.png';
import persoIcon from '../../assets/pictures/persoIcon.png';
import CommonBottomNavigation from '../../components/CommonDesign/BottomNavigation/BottomNavigation.view';
import store from '../../utils/store';

function Design({ darkTheme, classes, shopId, history = {}, openErrorModal }) {
  const { generalConfig = {} } = store.getState().firebaseRealTime;
  const {
    webapp = {},
    terminal = {},
    url = '',
    secondaryColor = '',
    descriptionText
  } = generalConfig;
  const { descriptionAddress } = webapp;
  const [stateObj, setStateObjRaw] = useState({
    isLoading: false,
    random: 0,
    selected: 1,
    selectedMode: 1,
  });
  const setStateObj = myNewObj => setStateObjRaw({ ...stateObj, ...myNewObj });
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [newSecondaryColor, setnewSecondaryColor] = useState('');
  const [background, setBackground] = useState('')

  useEffect(() => {
    initStates(darkTheme, descriptionText, secondaryColor, descriptionAddress, setStateObj, setnewSecondaryColor);
  }, [darkTheme, descriptionText, secondaryColor, webapp]);


  const renderDescriptionTitle = () => {
    const size = 300;
    return (
      <div elevation={0} className={classes.paper}>
        <p className={classes.designText}>Titre de description</p>
        <div>
          <Input
            margin='dense'
            type='text'
            id='descriptionText'
            variant='outlined'
            value={stateObj.descriptionText}
            multiline
            onChange={e =>
              setStateObj({
                [e.target.id]: e.target.value.substring(0, size)
              })
            }
            className={classes.inputStyle}
            placeholder='Ex:profitez de -20% de réduction sur...'
          />
        </div>
      </div>
    );
  };

  const renderAppTheme = title => {
    return (
      <div elevation={0} className={classes.paper}>
        <p className={classes.designText}>{title}</p>

        <CommonBottomNavigation
          collection={getCommonBottomNavigationData(classes)}
          selectedMode={stateObj.selectedMode}
          generalDesign
          classes={classes}
          onChange={(event, newValue) => changeSwitchValueMode(event, newValue, setStateObj)}
          onCheck={() => setStateObj({ selectedMode: stateObj.selectedMode === 1 ? 0 : 1 })}
        />
      </div>
    );
  };

  const renderStrctureDesign = () => {
    return (
      <div
        style={{
          marginTop: '2px',
          marginBottom: !displayColorPicker && UNIT * 7.3125
        }}
      >
        {renderAppTheme(`Thème de l'application`)}

        <div className={classes.structureDesign}>
          <div className={classes.paper}>
            <p className={classes.designText}>Couleurs</p>
            <List>
              <ListItem key='secondaryColor'>
                <ListItemIcon className={classes.iconColorStyle}>
                  <Swatch
                    color={background}
                    secondaryColor={newSecondaryColor}
                    onClick={() => setDisplayColorPicker(!displayColorPicker)}
                  />
                </ListItemIcon>
                <ListItemText>
                  {' '}
                  <Input
                    margin='dense'
                    type='text'
                    id='secondaryColor'
                    variant='outlined'
                    value={newSecondaryColor}
                    onChange={e =>
                      setnewSecondaryColor(
                        e.target.value
                      )
                    }
                    className={classes.inputStyle}
                  />{' '}
                </ListItemText>
                <ListItemIcon className={classes.colorIcon}>
                  <img src={colorIcon} alt='' className={classes.imageWidth} />
                </ListItemIcon>
              </ListItem>
            </List>

            {displayColorPicker && (
              <div
                className={classes.cover}
                onClick={() => setDisplayColorPicker(!displayColorPicker)}
              >
                <SketchPicker
                  color={newSecondaryColor}
                  onChange={color => handleChangeComplete(color, setnewSecondaryColor, setBackground)}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderDesign = () => {
    return (
      <div className='col-md-6 col-lg-5 col-xl-4 pl-md-0'>
        <div className={classes.personnalisationStyle}>
          <img src={persoIcon} className={classes.persoIcon} alt='' />
          <p className={classes.title}>Personnalisation générale</p>
        </div>
        <Paper elevation={1} className={classes.paperStyle}>
          <div className={classes.paper} style={{ height: UNIT * 31.5 }}>
            <div>{renderDescriptionTitle()}</div>
            {renderStrctureDesign()}
          </div>
          <div className='d-flex justify-content-center'>
            {stateObj.isLoading ? (
              <center>
                <Spinner className={classes.progress} />
              </center>
            ) : (
              <Button onClick={() => changeDesign(openErrorModal, stateObj.descriptionText, newSecondaryColor, stateObj.selectedMode, stateObj.random, setStateObj, darkTheme, descriptionAddress, setnewSecondaryColor)} className={classes.buttonStyle}>
                ENREGISTRER
              </Button>
            )}
          </div>
        </Paper>
      </div>
    );
  };

  const renderDesignType = () => {
    const { selected, selectedMode } = stateObj;
    const { enabled: enabledWebApp = false } = webapp;
    const { enabled: enabledTerminal = false } = terminal;
    const correctedUrl = enabledWebApp
      ? `${url}/commander`
      : enabledTerminal
        ? `${url}/terminal/${shopId}`
        : `${url}/qrcode/${shopId}`;
    const iconList = getBottomNavigationData(LIST_DESIGN_TYPE, classes);
    return (
      <div className='col-md-6 col-lg-7 col-xl-8 mb-2 mb-md-0 h-100 pr-md-0'>
        <div className={`col-md-1 col-lg-1 col-xl-1 ${classes.designTypeStyle}`}>
          <BottomNavigationIcon
            showLabels
            value={selected}
            onChange={(event, newValue) => changeSwitchValue(event, newValue, setStateObj)}
            collection={iconList}
          />
        </div>

        <div className={classes.root}>
          {selected === 1 ? (
            <div className={classes.designStyle}>
              <img
                src={selectedMode === 1 ? mobileLight : mobileDark}
                alt=''
                style={{ height: UNIT * 36 }}
              />
            </div>
          ) : (
            <div>
              <Iframe
                url={correctedUrl}
                width='100%'
                height={UNIT * 35.625}
                id='myId'
                key={stateObj.random}
                display={stateObj.displayFrame}

              />
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className='p-4'>
      <BackButton
        className='p-0'
        onClick={() => history.goBack()}
        title={marketing.general.text}
        subtitle={marketing.general.description}
      />

      <Paper className={`col-12 px-0 my-3 ${classes.body} `}>
        <div className={`row w-100 h-100 ${classes.marginStyle}`}>
          {renderDesignType()}
          {renderDesign()}
        </div>
      </Paper>
    </div>
  );

}

function mapStateToProps({ firebaseRealTime, user }) {
  const { generalConfig = {} } = firebaseRealTime;
  const { shopId = '' } = user;
  const {
    theme = '',
    webapp = {},
    terminal = {},
    qrcode = {},
    url = '',
    secondaryColor = '',
    descriptionText
  } = generalConfig;
  const { url: oldUrl = '', descriptionAddress } = webapp;

  return {
    darkTheme: theme === 'dark',
    descriptionText,
    url: url || oldUrl,
    terminal,
    webapp,
    qrcode,
    secondaryColor,
    shopId,
    descriptionAddress
  };
}

Design.propTypes = {
  classes: PropTypes.element.isRequired
};

export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(Design)));
